<template>
    <div
        class="ck-rendered-content display-html-content"
        v-html="htmlContent"></div>
</template>

<script>
export default {
    name: 'design-2021-apprentice-display-html-component',
    props: {
        htmlContent: String,
    },
};
</script>

<style scoped lang="scss">
.stripped-html {
    width: 100%;
}

.display-html-content ::v-deep {
    p {
        white-space: break-spaces;
        word-break: break-word;
    }
}
</style>
